
export default {
	openDropdown() {
		if (this.open) return;

		this.open = true;

		this.$nextTick(() => {
			const menu = this.$el.querySelector('.menu');
			if (!menu) return;

			const { bottom } = this.$el.getBoundingClientRect();
			const availableBelow = window.innerHeight - bottom;
			const gap = 5;

			this.shouldDropdownOpenUp = menu.offsetHeight > availableBelow + gap;
		});
	},
	closeDropdown() {
		this.open = false;
		this.shouldDropdownOpenUp = false;
	}
}



// WEBPACK FOOTER //
// ./src/utils/dropdownDirectionHelper.js